export const environment = {
    //baseURL: "http://localhost/api/",
    //baseURL:"https://api-provatis.provatis.academy/api/",
    baseURL: "https://hml-api.provatis.academy/public/api",
  };